import Handler from '../commonTypes/handler.types';

// Call each of the handlers on event
// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type, @typescript-eslint/no-explicit-any
function callHandlers(this: unknown, handlers: Array<Function>, ...args: any): void {
  handlers.forEach((handler) => {
    handler.apply(this, args);
  });
}

// An interface for holding onto the functions before merging
interface HandlerArr {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  [event: string]: Array<Function>;
}

// Takes the 'customHandlers' (what the user passes in through props)
// and the 'internalHandlers' (what the component needs internally)
// and combines them in a way that the internal handlers fire first and then
// the user custom ones.
const bindHandlers = (component: unknown, customHandlers: Handler, internalHandlers?: Handler): Handler => {
  const combinedHandlerArrays: HandlerArr = {};
  const combinedHandlers: Handler = {};

  const eventsUsed: Array<string> = [];

  // If internal handlers were passed, add them first (so they can be fired first)
  if (internalHandlers) {
    for (const event in internalHandlers) {
      combinedHandlerArrays[event] = [internalHandlers[event]];
      eventsUsed.push(event);
    }
  }

  // Add any custom handlers passed
  for (const event in customHandlers) {
    if (combinedHandlerArrays[event]) {
      combinedHandlerArrays[event].push(customHandlers[event]);
    } else {
      combinedHandlerArrays[event] = [customHandlers[event]];
      eventsUsed.push(event);
    }
  }

  // Bind all of the functions from both sets of handlers
  eventsUsed.forEach((event: string) => {
    combinedHandlers[event] = callHandlers.bind(component, combinedHandlerArrays[event]);
  });

  return combinedHandlers;
};

export default bindHandlers;
